import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollProgress from './ScrollProgress';
import RouteFallback from './RouteFallback';

/**
 * Persistent chrome for all public/marketing/marketplace routes. Keeping the
 * Navbar, Footer, background, and scroll bar mounted across navigations means
 * only the inner page swaps on a route change — no full-page teardown, so the
 * flicker between pages is gone. (Mirrors DashboardLayout for the authed area.)
 *
 * Every route gets the solid navbar. The home page used to open on a video
 * hero that a transparent bar floated over; it now opens on the marketplace.
 */
export default function PublicLayout() {
  return (
    <main className="relative min-h-screen bg-[var(--bg)] text-[var(--text)] grain">
      {/* Solid everywhere now: the home page opens on the marketplace grid
          rather than the video hero the transparent bar was made for. */}
      <Navbar solid />
      <ScrollProgress />
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
      <Footer />
    </main>
  );
}
